export type ApiRequestError = Error & {
  code?: number
  status?: number
  errorCode?: string
  data?: unknown
}

export interface ApiErrorResponse {
  code?: number
  message?: string
  error_code?: string
  data?: unknown
}

export function createApiRequestError(
  response: ApiErrorResponse,
  status: number,
  fallbackMessage: string
): ApiRequestError {
  const error = new Error(response.message || fallbackMessage) as ApiRequestError
  error.code = response.code
  error.status = status
  error.errorCode = response.error_code
  error.data = response.data
  return error
}
